import * as React from 'react'
import { PropsWithChildren, ReactElement } from 'react'
import { makeStyles, tokens } from '@fluentui/react-components'

export type IconValueProps = {
    icon: React.JSX.Element
}

const useStyles = makeStyles({
    wrapper: {
        alignSelf: 'center',
        alignItems: 'center',
        display: 'flex',
        gap: tokens.spacingHorizontalXS,
    },
})

export default function IconValue(props: PropsWithChildren<IconValueProps>): ReactElement {
    const styles = useStyles()

    return (
        <div className={styles.wrapper}>
            {props.icon}
            {props.children}
        </div>
    )
}
